export function readPricing(settings = {}) {
  const data = settings?.data ?? settings ?? {};
  const leadTypeCategories = data?.lead_type_categories ?? {};

  const leadTypeMap = {};
  Object.entries(leadTypeCategories).forEach(([categoryKey, category]) => {
    const price = Number(category?.price ?? 0);
    (category?.lead_types ?? []).forEach((leadType) => {
      leadTypeMap[leadType] = { category: categoryKey, price };
    });
  });

  return {
    leadTypeCategories,
    leadTypeMap,
    pricePerCounty: Number(data?.price_per_county ?? 25),
    discountPercent: Number(data?.yearly_discount_percent ?? 10),
    maxCounties: Number(data?.max_counties ?? 50),
    salesEmail: data?.sales_email ?? "",
    supportEmail: data?.support_email ?? "",
    supportPhone: data?.support_phone ?? "",
  };
}

export function getLeadTypePrice(leadTypeName, pricing) {
  return pricing.leadTypeMap?.[leadTypeName]?.price ?? 0;
}

export function calcLeadTypeTotal(leadTypeName, countyCount, pricing) {
  const basePrice = getLeadTypePrice(leadTypeName, pricing);
  return basePrice + Math.max(0, countyCount - 1) * pricing.pricePerCounty;
}

// Used by the landing page calculator — sums across selected types with mixed prices.
export function computeBundlePrice(
  pricing,
  selectedTypeKeys,
  counties,
  billing = "monthly",
) {
  const keys = Array.isArray(selectedTypeKeys) ? selectedTypeKeys : [];
  const co = Math.max(0, Number(counties) || 0);

  if (keys.length === 0) {
    return {
      monthlyTotal: 0,
      total: 0,
      monthlyEquivalent: 0,
      includedCounties: 0,
      extraCounties: 0,
    };
  }

  const monthlyLt = keys.reduce(
    (sum, k) => sum + getLeadTypePrice(k, pricing),
    0,
  );
  const extra = Math.max(0, co - keys.length);
  const monthlyExtra = pricing.pricePerCounty * extra;
  const monthlyTotal = monthlyLt + monthlyExtra;

  if (billing === "yearly") {
    const yearly =
      monthlyLt * 12 * (1 - pricing.discountPercent / 100) + monthlyExtra * 12;
    return {
      monthlyTotal,
      total: Math.round(yearly),
      monthlyEquivalent: Math.round(yearly / 12),
      includedCounties: keys.length,
      extraCounties: extra,
    };
  }
  return {
    monthlyTotal,
    total: Math.round(monthlyTotal),
    monthlyEquivalent: Math.round(monthlyTotal),
    includedCounties: keys.length,
    extraCounties: extra,
  };
}

export function formatPrice(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "$0";
  const v = Math.round(Number(n));
  return `$${v.toLocaleString()}`;
}
